import React, { ReactElement, useCallback, useEffect, useState } from "react";
import { Modal, Divider, Spin, message } from "antd";
const { confirm } = Modal;
import "./index.scss";
import { TitleList, EditTitle, DelTitle } from "../../../api/personal";
import { SvgIcon } from "../../../components/SvgIcon";

import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TitleModal from "../../../components/Modal/Title";
import { TitleType } from "@/utils/contants";
const Title: React.FC = () => {
  const [urlSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [personal, setPersonal] = useState<Array<TitlePerson>>([]);
  const [enterprise, setEnterprise] = useState<Array<TitleEnterprise>>([]);
  //事业单位/军队/政府机构
  const [government, setGovernment] = useState<Array<TitleEnterprise>>([]);
  const [modalInstance, setModalInstance] = useState(false);
  const [titleInfo, setTitleInfo] = useState<TitlePerson | TitleEnterprise>(
    null
  );
  const { t } = useTranslation();
  const [spinning, setSpinning] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();

  const fetchTitleList = useCallback(async () => {
    setSpinning(true);
    const res = await TitleList<{
      enterprise: Array<TitleEnterprise>;
      government: Array<TitleEnterprise>;
      person: Array<TitlePerson>;
    }>();
    setSpinning(false);
    if (res.code === 0) {
      const { enterprise, person, government = [] } = res.data;
      setGovernment(government);
      setEnterprise(enterprise);
      setPersonal(person);
      return;
    }
    messageApi.error(res.msg);
  }, []);

  useEffect(() => {
    fetchTitleList();
  }, [urlSearchParams.get("randomKey")]);

  const submitAction4Btn = useCallback(async (params) => {
    const res = await EditTitle(params);
    if (res.code === 0) {
      fetchTitleList();
    }
  }, []);

  const editItem = (item: TitlePerson | TitleEnterprise, type: 1 | 2 | 3) => {
    setTitleInfo({ ...item, type });
    setModalInstance(true);
  };

  const delItem = useCallback(async (item: TitlePerson | TitleEnterprise) => {
    confirm({
      title: `${t("删除")}${t("发票抬头")}`,
      okText: `${t("删除")}`,
      okType: "danger",
      cancelText: `${t("取消")}`,
      className: "confirm-ok-button",
      onOk() {
        return DelTitle({ id: item.id }).then((res) => {
          if (res.code === 0) {
            navigate(
              `${location.pathname}?randomKey=${Math.random()
                .toString(32)
                .slice(2)}`
            );
          }
        });
      },
      onCancel() {
        // console.log('Cancel');
      },
    });
  }, []);

  return (
    <section className="title-wrapper">
      {contextHolder}
      <section className="personal-wrapper-title">
        <div className="header">
          {t("个人")} {personal.length}
        </div>
        <div className="list-wrapper">
          {personal.length !== 0 ? (
            personal.map((item) => (
              <div className="personal-item" key={item.id}>
                <div className="text-wrapper">
                  <div className="title">{t("抬头名称")}:</div>
                  <div className="value">{item.title}</div>
                </div>
                <div className="btn-wrapper">
                  <div
                    className="btn"
                    onClick={() => editItem(item, TitleType.Personal)}
                  >
                    <SvgIcon
                      icon="icon-bianji"
                      width={16}
                      height={16}
                      attributes={{ fill: "var(--kx-fill-5)" }}
                    />
                    {t("编辑")}
                  </div>
                  <Divider type="vertical" />
                  <div className="btn" onClick={() => delItem(item)}>
                    <SvgIcon
                      icon="icon-shanchu"
                      width={16}
                      height={16}
                      attributes={{ fill: "var(--kx-fill-5)" }}
                    />
                    {t("删除")}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div
              className="empty-content"
              style={{ border: "none", height: "20rem" }}
            >
              <SvgIcon icon="icon-wuliebiao" />
              {t("暂无个人发票抬头")}
            </div>
          )}
        </div>
      </section>
      <section className="enterprise-wrapper">
        <div className="header">
          {t("企业或单位")} {enterprise.length}
        </div>
        <div className="list-wrapper">
          {enterprise.length !== 0 ? (
            enterprise.map((item) => (
              <div className="enterprise-item" key={item.id}>
                <div className="title-name-wrapper">
                  <div className="text-wrapper">
                    <div className="title">{t("抬头名称")}:</div>
                    <div
                      className="value"
                      style={{ fontWeight: 600, color: `var(--kx-text-1)` }}
                    >
                      {item.title}
                    </div>
                  </div>
                  <div className="btn-wrapper">
                    <div
                      className="btn"
                      onClick={() => editItem(item, TitleType.Company)}
                    >
                      <SvgIcon
                        icon="icon-bianji"
                        width={16}
                        height={16}
                        attributes={{ fill: "var(--kx-fill-5)" }}
                      />
                      {t("编辑")}
                    </div>
                    <Divider type="vertical" />
                    <div className="btn" onClick={() => delItem(item)}>
                      <SvgIcon
                        icon="icon-shanchu"
                        width={16}
                        height={16}
                        attributes={{ fill: "var(--kx-fill-5)" }}
                      />
                      {t("删除")}
                    </div>
                  </div>
                </div>
                <div className="text-wrapper">
                  <div className="title">{t("纳税人识别号")}:</div>
                  <div className="value">
                    {item.taxpayer_identification_number
                      ? item.taxpayer_identification_number
                      : "-"}
                  </div>
                </div>
                <div className="text-wrapper">
                  <div className="title">{t("开户银行")}:</div>
                  <div className="value">
                    {item.bank_name ? item.bank_name : "-"}
                  </div>
                </div>
                <div className="text-wrapper">
                  <div className="title">{t("银行账号")}:</div>
                  <div className="value">
                    {item.bank_card_no ? item.bank_card_no : "-"}
                  </div>
                </div>
                <div className="text-wrapper">
                  <div className="title">{t("企业地址")}:</div>
                  <div className="value">
                    {item.address ? item.address : "-"}
                  </div>
                </div>
                <div className="text-wrapper">
                  <div className="title">{t("企业电话")}:</div>
                  <div className="value">
                    {item.telephone ? item.telephone : "-"}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div
              className="empty-content"
              style={{ border: "none", height: "20rem" }}
            >
              <SvgIcon icon="icon-wuliebiao" />
              {t("暂无企业发票抬头")}
            </div>
          )}
        </div>
        {modalInstance && (
          <TitleModal
            hiddenModal={() => setModalInstance(null)}
            title={t("编辑发票抬头")}
            submitAction={(params) => submitAction4Btn(params)}
            titleInfo={titleInfo}
          />
        )}
      </section>
      <section className="enterprise-wrapper">
        <div className="header">
          {t("事业单位/军队/政府机构")} {government.length}
        </div>
        <div className="list-wrapper">
          {government.length !== 0 ? (
            government.map((item) => (
              <div className="enterprise-item" key={item.id}>
                <div className="title-name-wrapper">
                  <div className="text-wrapper">
                    <div className="title">{t("抬头名称")}:</div>
                    <div
                      className="value"
                      style={{ fontWeight: 600, color: `var(--kx-text-1)` }}
                    >
                      {item.title}
                    </div>
                  </div>
                  <div className="btn-wrapper">
                    <div
                      className="btn"
                      onClick={() => editItem(item, TitleType.Government)}
                    >
                      <SvgIcon
                        icon="icon-bianji"
                        width={16}
                        height={16}
                        attributes={{ fill: "var(--kx-fill-5)" }}
                      />
                      {t("编辑")}
                    </div>
                    <Divider type="vertical" />
                    <div className="btn" onClick={() => delItem(item)}>
                      <SvgIcon
                        icon="icon-shanchu"
                        width={16}
                        height={16}
                        attributes={{ fill: "var(--kx-fill-5)" }}
                      />
                      {t("删除")}
                    </div>
                  </div>
                </div>
                <div className="text-wrapper">
                  <div className="title">{t("纳税人识别号")}:</div>
                  <div className="value">
                    {item.taxpayer_identification_number
                      ? item.taxpayer_identification_number
                      : "-"}
                  </div>
                </div>
                <div className="text-wrapper">
                  <div className="title">{t("开户银行")}:</div>
                  <div className="value">
                    {item.bank_name ? item.bank_name : "-"}
                  </div>
                </div>
                <div className="text-wrapper">
                  <div className="title">{t("银行账号")}:</div>
                  <div className="value">
                    {item.bank_card_no ? item.bank_card_no : "-"}
                  </div>
                </div>
                <div className="text-wrapper">
                  <div className="title">{t("企业地址")}:</div>
                  <div className="value">
                    {item.address ? item.address : "-"}
                  </div>
                </div>
                <div className="text-wrapper">
                  <div className="title">{t("企业电话")}:</div>
                  <div className="value">
                    {item.telephone ? item.telephone : "-"}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div
              className="empty-content"
              style={{ border: "none", height: "20rem" }}
            >
              <SvgIcon icon="icon-wuliebiao" />
              {t("暂无企业发票抬头")}
            </div>
          )}
        </div>
        {modalInstance && (
          <TitleModal
            hiddenModal={() => setModalInstance(null)}
            title={t("编辑发票抬头")}
            submitAction={(params) => submitAction4Btn(params)}
            titleInfo={titleInfo}
          />
        )}
      </section>
      {spinning && (
        <div className="spin-wrapper">
          <Spin size="large" spinning={spinning} />
        </div>
      )}
    </section>
  );
};

export default Title;
